/* eslint-disable no-underscore-dangle */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import styles from './pages.module.css';
import { useSelector, RootState, useDispatch } from '../services/store';
import { TIngredientType, WebsocketStatus } from '../utils/types';
import { WS_URL } from '../utils/constants';
import {
    connect as wsConnect,
    disconnect as wsDisconnect,
} from '../services/wsAll/actions';
import OrderHistoryCard from '../components/order-history-card/order-history-card';

function Feed(): JSX.Element {
    const all = useSelector((store: RootState) => store.fetch.data);
    const items: { [id: string]: TIngredientType } = {};
    if (all) {
        all.forEach((item) => {
            items[item._id] = item;
        });
        // console.log(items);
    }
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { data, status, total, totalToday } = useSelector((s) => s.socket);
    const isConnected = status !== WebsocketStatus.OFFLINE;

    useEffect(() => {
        if (!isConnected) dispatch(wsConnect(WS_URL));
        return () => dispatch(wsDisconnect());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className={styles.feed}>
            <div className={styles.feed_header}>
                <div className="pl-8 p-2 text_type_main-medium">
                    Лента заказов
                </div>
                <div
                    className={`${styles.feed_block} text text_type_main-normal`}
                >
                    {isConnected &&
                        all &&
                        data.map((order) => (
                            <OrderHistoryCard
                                wsOrder={order}
                                items={items}
                                onClick={() =>
                                    navigate(`/feed/${order.number}`, {
                                        state: { background: location },
                                    })
                                }
                            />
                        ))}
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '40px',
                        justifyContent: 'space-around',
                        width: '588px',
                    }}
                    className="text_type_main-default pt-8"
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            height: '300px',
                        }}
                        className="text_type_main-default"
                    >
                        <div className="p-4">Готовы</div>
                        <div
                            style={{
                                display: 'inline-flex',
                                flexWrap: 'wrap',
                                flexDirection: 'column',
                                alignItems: 'center',
                                height: '180px',
                            }}
                            className="text_type_main-default"
                        >
                            {isConnected &&
                                all &&
                                data
                                    .filter((order) => order.status === 'done')
                                    .slice(0, 10)
                                    .map((order) => (
                                        <div
                                            className="p-1"
                                            style={{ color: '#00CCCC' }}
                                            key={uuid()}
                                        >
                                            {order.number}
                                        </div>
                                    ))}
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            height: '300px',
                        }}
                    >
                        <div className="p-4">В работе</div>
                        <div
                            style={{
                                display: 'inline-flex',
                                flexWrap: 'wrap',
                                flexDirection: 'column',
                                alignItems: 'center',
                                height: '180px',
                            }}
                            className="text_type_main-default"
                        >
                            {isConnected &&
                                all &&
                                data
                                    .filter(
                                        (order) => order.status === 'pending'
                                    )
                                    .slice(0, 10)
                                    .map((order) => (
                                        <div className="p-1" key={uuid()}>
                                            {order.number}
                                        </div>
                                    ))}
                        </div>
                    </div>
                </div>
                <div className="pl-8 text_type_main-medium">
                    Выполнено за все время
                </div>
                <div className="pl-8 text text text_type_digits-large">
                    {total}
                </div>
                <div className="pl-8 text_type_main-medium">
                    Выполнено за сегодня
                </div>
                <div className="pl-8 text text text_type_digits-large">
                    {totalToday}
                </div>
            </div>
        </div>
    );
}

export default Feed;

// if (!item && id && data.length) {
// eslint-disable-next-line no-underscore-dangle
// [item] = data.filter((i: TIngredientType) => i._id === id);
// }
